// removed by extract-text-webpack-plugin
module.exports = {"black":"_3htktpfKJVNLgXo21e18ly","white":"oLe_0PbrRMEOVn-Wmivup","red":"#e40000","dark-red":"#a30000","light-grey":"#d4d4d4","medium-grey":"#9f9f9f","mobile-s":"320px","fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)","btn":"_3c-TKp__p2E3-fzA0083TO","button-tap":"UvP6WZiJ8vHJdkc4rx--k","disabled":"_2Da9u12kG6J51f4okFQcMp","sticky":"_8Aq6PuIv1DR71OUoGrpC","secondary":"_1DqzgX_aXYN4ha93gmyyXT","special":"wciGpSGqejIf2tZHp_NdB","next":"_3ozxizMMWWQ0Iw__W9asGx","cancel":"_1MFuvSYQwDd15R31uSKU1x","with-icon":"iHwPk0C7X3sO344zD3q8n","right":"_1hu1D71zcnUfxMAuk6rwm-","small":"_2dvI1-UykviFhXmXDh-B--"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Buttons/Button.css
// module id = 887
// module chunks = 0